module.exports = new __parcel__URL__("switzerland-flag.7ac4fd48.svg").toString();